export const seoKeywords = {
  name: 'keywords',
  content:
    'NFT development services, NFT marketplace development, NFT development company, own NFT marketplace, NFT developers to hire, blockchain developers to hire, non-fungible tokens development',
};

export const nftDevelopmentPageSeo = {
  title: 'NFT Development Company | Rumble Fish',
  meta: [
    seoKeywords,
    {
      name: 'description',
      content:
        'Rumble Fish is an NFT Development Company that will help you build your custom NFT marketplace or an NFT collection. Our non-fungible tokens (NFTs) platform development expertise allows us to be at the forefront of this highly lucrative market.',
    },
  ],
};
